import PropTypes from 'prop-types';
import * as React from 'react';
import './Footer.scss';

export const Footer = () => {
	const menuItems = [{
		text: 'Footer Info',
		href: 'https://nem.io'
	}, {
		text: 'Social Link',
		href: 'https://nem.io'
	}, {
		text: 'Social Link',
		href: 'https://nem.io'
	}, {
		text: 'Social Link',
		href: 'https://nem.io'
	}, {
		text: 'Compliance Docs',
		href: 'https://nem.io'
	}, {
		text: 'Contact Info',
		href: 'https://nem.io'
	}];

	return (
		<div className="footer">
			<div className="footer-menu">
				{menuItems.map((item, index) => (
					<>
						{index !== 0 && <span>|</span>}
						<a href={item.href} key={'footer' + index}>
							{item.text}
						</a>
					</>
				))}
			</div>
		</div>
	);
};

Footer.propTypes = {};
